import {
  CalendarItemUnion,
  getCalendarItemBackgroundColor,
} from '@akin-home/calendar/combined';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { format } from 'date-fns';
import styled from 'styled-components/native';

type Props = {
  item: CalendarItemUnion;
  onPress?(item: CalendarItemUnion): void;
};

export function CalendarWeekItem(props: Props) {
  const { item } = props;

  function onPress() {
    props.onPress?.(item);
  }

  return (
    <ItemCard color={getCalendarItemBackgroundColor(item)} onPress={onPress}>
      <Text weight="semibold" numberOfLines={3}>
        {item.title}
      </Text>
      <Text variant="p2" weight="semibold" color={colors.neutral[70]}>
        {format(item.start, 'h:mm a')}
      </Text>
    </ItemCard>
  );
}
const ItemCard = styled.TouchableOpacity<{ color: string }>`
  background-color: ${({ color }) => color};
  padding: 16px;
  border-radius: 15px;
  margin-top: 4px;
  margin-bottom: 4px;
`;
